import { cn, SupportIcon, Text } from '$components'

type SupportLinkProps = {
  onClick: () => void
}

export function SupportLink({ onClick }: SupportLinkProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex gap-stack-tight p-stack items-center rounded-card-sm w-full',
        'hover:bg-bg-subtle text-fg',
      )}
    >
      <SupportIcon className="size-[20px] min-w-[20px] min-h-[20px]" />

      <Text type="s" className="truncate">
        Support
      </Text>
    </button>
  )
}
